__turbopack_context__.v({
  "content": "QeBw7a_content",
  "foundation": "QeBw7a_foundation",
  "theme": "QeBw7a_theme",
});
